import React from 'react';
import { Field, TextOutput } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetResultsSection, WorksheetsResultsMessagesSection } from '../../../Core';
import { MddChartSection } from '../../Shared';

const contextCaptions = [
  { path: `data.Preparation.ScreeningASTM`, caption: 'Oversize Determination' },
  { path: `data.TestPortions`, caption: 'Test Portions' },
];

let ResultsSection: React.FC = () => {
  return (
    <WorksheetResultsSection heading="Results">
      <MddChartSection
        // Cannot customise curve fitting as points are joined by straight lines
        hideCurveFittingSelection={true}
      />
      <WorksheetsResultsMessagesSection contextCaptions={contextCaptions} />
      <ListFieldSection heading="Laboratory Results">
        <Field label="Maximum Dry Density" input={<TextOutput />} name="Results.MaximumDryDensity" emph />
        <Field label="Optimum Moisture Content (%)" input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
    </WorksheetResultsSection>
  );
};

ResultsSection = withInjectedProps(ResultsSection);

export { ResultsSection };
export default ResultsSection;
